import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../component/Header';
import PublicFooter from '../../components/layout/PublicFooter';
import blogPosts from './blogData';
import SEO from '../../components/SEO';

const BlogIndex = () => {
  const featured = blogPosts[0];
  const rest = blogPosts.slice(1);

  return (
    <div style={{ fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}>
      <Header />

      <SEO
        title="Blog - Vehicle Registration Tips & Guides"
        description="Expert guides on car tag renewal, plate registration, DMV tips, and vehicle registration fees. Stay informed and never miss a renewal deadline."
        canonical="/blog"
      />

      {/* Hero */}
      <div className="tw-relative tw-overflow-hidden">
        <div className="tw-absolute tw-inset-0">
          <img src={process.env.PUBLIC_URL + '/images/hero-blog.jpg'} alt="Person using phone and laptop to manage vehicle registration online" className="tw-w-full tw-h-full tw-object-cover" />
          <div className="tw-absolute tw-inset-0 tw-bg-gray-900/70"></div>
        </div>
        <div className="tw-relative tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-text-center tw-py-14 md:tw-py-20">
          <h1 className="tw-text-4xl md:tw-text-5xl tw-text-white tw-m-0">RMT Blog</h1>
          <p className="tw-text-lg tw-text-gray-300 tw-mt-3 tw-mb-0 tw-max-w-2xl tw-mx-auto">
            Guides, tips, and insights on vehicle registration, plate renewal, and keeping your tags current.
          </p>
        </div>
      </div>

      <div className="tw-max-w-5xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-py-12 md:tw-py-16">
        {/* Featured Post */}
        <Link to={`/blog/${featured.slug}`} className="tw-block tw-group tw-no-underline tw-mb-12">
          <div className="tw-bg-white tw-rounded-2xl tw-border tw-border-gray-200 tw-shadow-sm tw-overflow-hidden hover:tw-shadow-lg tw-transition-shadow">
            <div className="tw-bg-gradient-to-br tw-from-blue-50 tw-to-primary-50 tw-px-8 tw-py-12 md:tw-px-12 md:tw-py-16">
              <span className="tw-inline-block tw-text-xs tw-font-semibold tw-text-primary-600 tw-uppercase tw-tracking-wider tw-bg-primary-100 tw-px-3 tw-py-1 tw-rounded-full tw-mb-4">{featured.category}</span>
              <h2 className="tw-text-2xl md:tw-text-3xl tw-text-gray-900 tw-m-0 tw-mb-3 group-hover:tw-text-primary-600 tw-transition-colors">{featured.title}</h2>
              <p className="tw-text-gray-600 tw-m-0 tw-mb-4 tw-text-lg tw-leading-relaxed">{featured.excerpt}</p>
              <div className="tw-flex tw-items-center tw-gap-3 tw-text-sm tw-text-gray-500">
                <span>{featured.date}</span>
                <span className="tw-text-gray-300">·</span>
                <span>{featured.readTime}</span>
              </div>
            </div>
          </div>
        </Link>

        {/* Post Grid */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">
          {rest.map((post) => (
            <Link key={post.slug} to={`/blog/${post.slug}`} className="tw-block tw-group tw-no-underline">
              <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-200 tw-shadow-sm tw-p-6 hover:tw-shadow-lg tw-transition-shadow tw-h-full tw-flex tw-flex-col">
                <span className="tw-inline-block tw-text-xs tw-font-semibold tw-text-primary-600 tw-uppercase tw-tracking-wider tw-mb-3">{post.category}</span>
                <h3 className="tw-text-lg tw-text-gray-900 tw-m-0 tw-mb-2 group-hover:tw-text-primary-600 tw-transition-colors tw-leading-snug">{post.title}</h3>
                <p className="tw-text-sm tw-text-gray-600 tw-m-0 tw-mb-4 tw-leading-relaxed tw-flex-1">{post.excerpt}</p>
                <div className="tw-flex tw-items-center tw-gap-3 tw-text-xs tw-text-gray-400">
                  <span>{post.date}</span>
                  <span className="tw-text-gray-300">·</span>
                  <span>{post.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default BlogIndex;
